<template>
  <footer class="footer-container">
    <div class="container">
      <div class="row justify-content-around py-4">
        <div class="col-7 col-lg-3">
          <img
            src="../assets/Logo_final_blanco.png"
            alt=""
            style="width: 50%; height: 65px; "
          />

          <div class="row">
            <!--             <img src="../assets/icon_send.svg" alt="" width="10%" class="mr-3">
            <p>ventas@fyf.mx</p> -->
          </div>
        </div>
        <div
          class="col-6 col-lg-3"
          style="margin-top: 1.5rem !important; margin-bottom: auto"
        >
          <p class=""><strong>Información de contacto</strong></p>
          <a href="mailto:jc@jobot.mx" target="_blank"
            ><img
              src="../assets/mail_logo.svg"
              alt=""
              width="15%"
              class="mx-1 my-3"
              style="margin-top: 0rem !important;"
          /></a>
          <a
            href="https://api.whatsapp.com/send/?phone=5534316959&text=%C2%A1Hola!%20Estoy%20interesado%20en%20solicitar%20una%20demo%20de%20los%20servicios%20de%20FyF%20Soluciones."
            target="_blank"
            ><img
              src="../assets/wa_logo.svg"
              alt=""
              width="15%"
              class="mx-1 my-3"
              style="margin-top: 0rem !important;"
          /></a>
          <a href="https://www.facebook.com/fyfmx" target="_blank"
            ><img
              src="../assets/fb_logo.svg"
              alt=""
              width="15%"
              class="mx-1 my-3"
              style="margin-top: 0rem !important;"
          /></a>
          <a href="https://www.linkedin.com/company/f-f-soluciones/" target="_blank"
          ><img
              src="../assets/linkedin.svg"
              alt=""
              width="15%"
              class="mx-1 my-3"
              style="margin-top: 0rem !important; color: white"
          /></a>
          <a href="https://www.instagram.com/fyfsolucionesatumedida/" target="_blank"
          ><img
              src="../assets/instagramg.svg"
              alt=""
              width="15%"
              class="mx-1 my-3"
              style="margin-top: 0rem !important; color: white"
          /></a>
        </div>

        <div           class="col-6 col-lg-3"
          style="margin-top: 1.5rem !important; margin-bottom: auto">
          <p class=""><strong>Ubicación</strong></p>
          <div class="row justify-content-center mb-3">
            <img
              src="../assets/icon_gps.svg"
              alt=""
              width="10%"
              class="mr-3"
              style="margin-bottom: auto; margin-top: auto; display: inline-block;"
            />
            <p style="display: inline-block; margin: 0;">Cuautitlán Izcalli, <br>Estado de México</p>
          </div>
        </div>
      </div>
<!--       <a class="nav-link " href="#fyf"  @click="to('Landing')">Acerca de</a> -->
      <a
        class=" nav-link row justify-content-center pb-3"
        href="AvisoDePrivacidad"
        target="_blank"
        @click="to('AvisoDePrivacidad')"
      ><p style="color: white;">Aviso de privacidad</p></a>
      <div class="row justify-content-center pb-3">
        © 2023 F&F soluciones en código.
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  methods: {
    enviarCorreo() {
      window.location.href = 'mailto:jc@jobot.mx';
    }
  }
};

</script>

<style scoped>
footer {
  background-color: #2f395d;
  color: white;
}
.footer-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
    }

    .footer-container .row {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
    }

    .footer-container p {
      margin: 0;
    }
</style>
